<template>
	
		<mapbase 
		:mapColor="mapColor" 
		:mapTitle="mapTitle" 
		:mapName="mapName" 
		:unit="unit" 
		:pieces="pieces"
		:cityD="cityD"
		:provicesD="provicesD"
		/>
		<!-- <mapbase /> -->
	
</template>

<script>
	import mapbase from './mapbase.vue'
	import '../../static/js/provinceWaterSave.js'
	import '../../static/js/cityWaterSave.js'
	export default {
		name: 'mapuse',
		components: {
			mapbase,
		},
		data(){
			return {
				cityD:cityWaterSave,
				provicesD:provinceWaterSave,
				unit:'万立方米',
				mapName:'城市节约用水量',
				mapTitle:'2018年城市节约用水量地图(万立方米)',
				mapColor:['#fff', '#ECFCCC', '#DEF2A7', '#CFE882', '#BEDE5F', '#B0D63C','#9DCC10'],
				pieces:[
							{
								min:11875.000001
							}, 
							{
								min: 6484.000001 ,
								max:11875.000000
							},
							{
								min: 4000.000001  ,
								max: 6484.000000
							},
							{
								min: 2122.030001 ,
								max: 4000.000000
							},
							{
								min: 862.000001 ,
								max: 2122.030000
							},
							{
								min: 116,
								max:  862.000000
							},
							{
								min: 0,
								max: 116
							}
							
						]
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: calc(100vh - 200px);
		margin: auto;
		/* border: 2px solid aquamarine; */
	}
	
	.search{
		margin-right: 30px;
		text-align: right;
		margin-bottom: 20px;
	}
	.search .el-input{
		width:30%
	}
	@media screen and (max-width:600px) {
		.search .el-input{
			width:50%
		}
	}
</style>
